import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Input from '../reuseable/Input';
import { generate_elevation_mapbox, } from '../../App/actions/toolboxActions';
import ProgressBarButton from '../reuseable/ProgressBarButton';
import useLanguage from '../common_hooks/useLanguage';
import { snackbar } from '../../App/actions/snackbarActions';


function SETTING_ELEVATION() {

  const { dict, language } = useLanguage();
  const toolbox = useSelector((state) => (state.toolbox)) || {};
  const { name_toolbox, uuid_name, mode_toolbox } = toolbox;
  const [number_of_samples, set_number_of_samples] = useState("-");

  const selected_row_toolbox_ids = toolbox[uuid_name];
  const features = toolbox[mode_toolbox];
  const [loading_progress, set_loading_progress] = useState(0);
  const [is_loading, set_is_loading] = useState(false);


  const dispatch = useDispatch();

  const handle_get_elevation = async () => {
    if (number_of_samples < 2) {
      dispatch(snackbar({
        is_open: true,
        message: dict["Number of samples must be greater than 1"][language],
        status: "warning"
      }));
      return
    }

    set_loading_progress(0)
    set_is_loading(true)
    const selected_features = features.filter(feature => selected_row_toolbox_ids.includes(feature.properties.uuid));

    for (const [index, f] of selected_features.entries()) {
      set_loading_progress(parseInt(((index + 1) / features.length) * 90))
      if (selected_row_toolbox_ids.includes(f.properties.uuid)) {
        await dispatch(generate_elevation_mapbox(f, number_of_samples));
      };
    }

    set_loading_progress(100)
    set_is_loading(false)
  }

  const on_change_number_of_samples = (e) => {
    const value = parseFloat(e.target.value);
    set_number_of_samples(value);
  }


  return (
    <div
      style={{
        width: "230px",
        // width: "360px",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        margin: "10px 0 10px 0",
      }}
    >
      {name_toolbox &&
        <section
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <div
            style={{
              fontWeight: 700,
              fontSize: "16px",
              lineHeight: "19px",
              color: "#000000",
            }}
          >
            {language === "ina" && `${dict["Setting"][language]} `}
            {`${name_toolbox}`}
            {language === "eng" && ` ${dict["Setting"][language]}`}
          </div>

          {/* {selected_row_toolbox_ids?.length > 0 &&  */}
          <div
            style={{
              fontSize: "12px",
              color: "#000000",
            }}
          >
            {`${selected_row_toolbox_ids?.length} Selected`}
          </div>
          {/* } */}
        </section>
      }

      <hr />

      <section>
        <span style={{ fontSize: "14px" }}>{dict[`Number of Samples`][language]}</span>
        <Input
          style={{ margin: "15px 0 15px 0" }}
          value={number_of_samples}
          type="number"
          onChange={(e) => on_change_number_of_samples(e)}
          max={100}
        />
      </section>

      <section>
        <ProgressBarButton
          progress={loading_progress}
          is_loading={is_loading}
          onClick={() => {
            if (!isNaN(number_of_samples)) handle_get_elevation()
          }}
        >
          {dict["Generate"][language]}
        </ProgressBarButton>
      </section>
    </div >

  )
}

export default SETTING_ELEVATION